// extracted by mini-css-extract-plugin
export var stripesBg = "Questions-module--stripes-bg--15mYZ";
export var columns = "Questions-module--columns--2hBgK";
export var wrapper = "Questions-module--wrapper--2iAQs";
export var contactIcon = "Questions-module--contact-icon--s0EVV";
export var spinAround = "Questions-module--spinAround--2p1WY";